// extracted by mini-css-extract-plugin
export var createdDate = "_jk-1";
export var divider = "_jk-2";
export var headerDivider = "_jk-3";
export var messagesCard = "_jk-0";
export var messagesContainer = "_jk-6";
export var messagesContainerWrapper = "_jk-4";
export var showLeftPanelButton = "_jk-8";
export var topButtons = "_jk-7";
export var withPadding = "_jk-5";